const moveSearch = () => {
  if ($('.left-nav.desktop .right-side-btns').length === 0) {
    $('.nav-login-btn').before($('.right-side-btns'));
  }
};

const toggleSearch = () => {
  const searchToggle = document.querySelector('.search-toggle');
  const topNav = document.querySelector('.top-nav');

  // open search
  document
    .querySelector('.left-nav.desktop .search-toggle')
    .addEventListener('click', () => {
      topNav.classList.remove('disabled');
      searchToggle.classList.add('expanded');
    });

  // close search when anywhere outside of search is clicked
  document.addEventListener(
    'click',
    function(e) {
      if (
        e.target.classList !== searchToggle.classList &&
        !searchToggle.contains(e.target) &&
        !e.target.className.match('search-toggle')
      ) {
        searchToggle.classList.remove('expanded');
      }
    },
    false
  );
};

export { moveSearch, toggleSearch };



// WEBPACK FOOTER //
// ./partial-scripts/moveSearch.js